<template>
    <div class="pay">
        <el-dialog title="购买支付" :visible.sync="dialogVisible" width="826px" :before-close="handleClose">
            <div class="main">
                <div class="list">
                    <div :class="{ item: true, on: sle_index === i }" v-for="(v, i) in item.amount" :key="i" @click="selectIndex(i, v)">
                        <div class="price" v-if="Number(v.amount) != 0">
                            <p>{{ Number(v.amount) == 0 ? Number(v.days) + "天" : Number(v.years) * 12 + Number(v.months) + "个月" }}</p>
                            <p style="color: #ed3c3e">
                                ￥<span>{{ v.amount }}</span>
                            </p>
                        </div>
                        <div class="price" v-else>
                            <p>试用</p>
                            <p style="color: #ed3c3e">
                                ￥<span>{{ v.amount }}</span>
                            </p>
                            <span class="use"
                                >免费试用<span style="color: #ed3c3e">{{ Number(v.days) }}</span
                                >天</span
                            >
                        </div>
                    </div>
                </div>
                <div class="code">
                    <div class="left">
                        <div class="item">
                            <div :class="{ active: type == 2, til: true }" @click="showBg('wx')">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-weixinzhifu"></use>
                                </svg>
                                <p>微信支付</p>
                            </div>
                        </div>
                        <div class="item">
                            <div :class="{ active: type == 1, til: true }" @click="showBg('zfb')">
                                <svg class="icon" aria-hidden="true" style="width: 28px; height: 24px">
                                    <use xlink:href="#icon-zhifupingtai-zhifubao"></use>
                                </svg>
                                <p>支付宝支付</p>
                            </div>
                        </div>
                    </div>
                    <div class="right" v-if="isshow">
                        <div :class="{ active: type == 1 || type == 2, img: true }">
                            <div class="div" v-loading="urlLoad" element-loading-text="加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                                <vue-qr :text="qrUrl" qid="testid" :margin="0" v-if="qrUrl"></vue-qr>
                                <div class="block" v-else>
                                    <el-image>
                                        <div slot="error" class="image-slot">
                                            <i class="el-icon-picture-outline"></i>
                                        </div>
                                    </el-image>
                                </div>
                            </div>
                        </div>
                        <div class="price_right" style="margin-left: 20px">
                            <h4 style="color: #ed3c3e" v-if="price_str != ''">
                                ￥ <span>{{ price_str }}</span>
                            </h4>
                            <p v-show="type == 1">支付宝扫码</p>
                            <p v-show="type == 2">微信扫码</p>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer"> </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueQr from "vue-qr";
export default {
    data() {
        return {
            dialogVisible: false,
            type: "",
            qrUrl: "",
            urlLoad: false,
            timer: null,
            sle_index: null,
            isshow: false,
            price_str: "",
        };
    },
    components: { VueQr },
    props: {
        id: {
            type: Number,
            default: 0,
        },
        price: {
            type: Number,
            default: 0,
        },
        item: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            applicationOrder: "activity/applicationOrder",
            getPayment: "activity/getPayment",
            getPayQuery: "activity/getPayQuery",
        }),
        selectIndex(i, v) {
            this.price_str = v.amount;
            this.sle_index = i;
            this.showBg("wx");
        },
        checkPay(id) {
            let opt = {
                id: id,
                token: this.getToken,
            };
            this.getPayQuery(opt).then(({ data }) => {
                if (data.code == 1) {
                    if (data.data.status == 2) {
                        clearInterval(this.timer);
                        this.$message.success("支付成功！");
                        this.dialogVisible = false;
                        this.$emit("init");
                    } else if (data.data.status == 3) {
                        clearInterval(this.timer);
                        this.$message.error("支付失败！");
                    }
                }
            });
        },
        handleClose() {
            clearInterval(this.timer);
            this.type = "";
            this.qrUrl = "";
            this.urlLoad = false;
            this.sle_index = "";
            this.isshow = false;
            this.dialogVisible = false;
        },
        Pay(id) {
            this.getPayment({ id: id }).then(({ data }) => {
                this.urlLoad = false;
                if (data.code == 1) {
                    this.qrUrl = data.data.pay_url;
                    if (!data.data.pay_url) {
                        this.$message.warning("已提交过申请，请等待审核！");
                        this.imgDialog = false;
                    } else {
                        this.qrUrl = data.data.pay_url;
                        this.urlLoad = false;
                        let i = 0;
                        this.timer = setInterval(() => {
                            this.checkPay(id);
                            i++;
                            if (i >= 20) {
                                clearInterval(this.timer);
                            }
                        }, 3000);
                    }
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        showBg(typeStr) {
            this.isshow = true;
            if (typeStr == "wx") {
                this.type = 2;
            } else {
                this.type = 1;
            }
            let params = {
                token: this.getToken,
                id: this.id,
                type: this.type,
                price_id: this.item.amount[this.sle_index].id,
            };
            this.urlLoad = true;
            this.applicationOrder(params).then(({ data }) => {
                if (data.code == 1) {
                    if (data.data.payment_id == 0) {
                        this.$message.success("已获取试用时间！");
                        this.$emit("init");
                        this.handleClose();
                        return;
                    }
                    this.Pay(data.data.payment_id);
                } else {
                    this.$message.error(data.msg);
                    this.urlLoad = false;
                }
            });
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>

<style lang="scss" scoped>
.pay {
    .main {
        & > .list {
            display: flex;
            flex-wrap: wrap;
            .item.on {
                border: 2px solid #2448ff;
                background: url("../../../assets/img/icon_xuanzhon.png") no-repeat bottom right;
                overflow: hidden;
                background-size: 24px 24px;
            }
            .item {
                padding-top: 30px;
                cursor: pointer;
                width: 160px;
                height: 200px;
                background: #ffffff;
                border: 2px solid #d3d3d3;
                border-radius: 8px;
                margin: 16px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                p {
                    line-height: 50px;
                    font-size: 18px;
                    span {
                        font-size: 24px;
                    }
                }
            }
        }
        text-align: center;
        .price {
            font-size: 16px;
            color: #333;
            font-weight: 600;
            span {
                color: #f13f3f;
            }
            .use {
                font-size: 14px;
                color: #666;
            }
        }
        & > span {
            display: block;
            margin-top: 34px;
            color: #666;
            font-size: 14px;
        }
        & > .img.active {
            visibility: inherit;
        }
        & > .img {
            padding: 8px;
            border: 1px solid #eee;
            border-radius: 6px;
            width: 161px;
            height: 161px;
            margin: 40px auto;
            visibility: hidden;
        }
        .code {
            margin: 16px;
            height: 200px;
            background: #ffffff;
            border: 1px solid #d3d3d3;
            border-radius: 8px;
            display: flex;
            .left {
                width: 180px;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                .item {
                    &:nth-child(1) {
                        .img {
                            border-color: #4bb316;
                        }
                        .til.active {
                            border: 2px solid #38b035;
                            border-radius: 20px;
                        }
                    }
                    &:nth-child(2) {
                        .img {
                            border-color: #01a3ef;
                            border-radius: 20px;
                        }
                        .til.active {
                            border: 2px solid #00b4ff;
                            border-radius: 20px;
                        }
                    }
                    .til {
                        border: 2px solid #d3d3d3;
                        width: 140px;
                        margin: 14px 0;
                        background: #fff;
                        border-radius: 20px;
                        align-items: center;
                        margin: 8px 20px;
                        cursor: pointer;
                        line-height: 40px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        p {
                            margin-left: 6px;
                            font-size: 14px;
                            color: #333;
                        }
                    }
                }
            }
            .right {
                padding-left: 60px;
                flex: 1;
                display: flex;
                align-items: center;
                .img {
                    img,
                    .el-image {
                        width: 140px;
                        height: 140px;
                        background: #eee;
                        font-size: 36px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .price_right {
                    text-align: left;
                    h4 {
                        font-size: 18px;
                        margin-bottom: 14px;
                        span {
                            font-size: 24px;
                        }
                    }
                    p {
                        padding-left: 4px;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
.icon {
    width: 24px;
    height: 24px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}
</style>